import script from "./templateItem.vue?vue&type=script&setup=true&lang=js"
export * from "./templateItem.vue?vue&type=script&setup=true&lang=js"

import "./templateItem.vue?vue&type=style&index=0&id=05e7c03f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05e7c03f"]])

export default __exports__